import { PLATFORMS, CFD_MODAL_TYPE } from 'pages/views/devices/types';
import store from 'pages/store';

export const APP_NAME = 'Lightspeed Hub';
export const PROTOCOL = 'ls-hub://';
export const PROTOCOL_IFRAME = 'protocol-iframe';

export const getDetectedPlatform = () => {
  let platform: PLATFORMS | null = null;
  if (navigator.platform.includes('Mac')) {
    platform = PLATFORMS.MAC;
  } else if (navigator.platform.includes('Win')) {
    platform = PLATFORMS.WINDOWS;
  }

  return { platform };
};

export const setCfdModal = (cfdModal: CFD_MODAL_TYPE | undefined) => {
  store.dispatch({ type: 'HUB_UPDATE_CFD_MODAL', payload: { cfdModal } });
};
